import _ from 'lodash';
import { api } from '@/resources/utils/api';

import App from '@/views/constants/app';

import Policies from '@/resources/constants/policies';
import Policy from '@/resources/models/policies';

const state = {
  policies: [],

  policiesErrors: [],
  isPoliciesLoading: false
};

const getters = {
  policies: state => state.policies,
  activePolicies: state => state.policies.filter(p => p.isActive),
  policiesErrors: state => state.policiesErrors,
  isPoliciesLoading: state => state.isPoliciesLoading
};

const actions = {
  [Policies.Actions.LoadAll.START] ({ commit, dispatch }, payload) {
    commit(Policies.Mutations.IsLoading.SET, true);

    api.get(encodeURI(Policies.Endpoints.LoadAll(payload)))
      .then((response) => dispatch(Policies.Actions.LoadAll.SUCCESS, response.data))
      .catch((errors) => dispatch(Policies.Actions.LoadAll.FAILED, errors))
      .finally(() => commit(Policies.Mutations.IsLoading.SET, false));
  },

  [Policies.Actions.LoadAll.SUCCESS] ({ commit }, payload) {
    commit(Policies.Mutations.SET, _.map(payload, data => new Policy(data)));
  },

  [Policies.Actions.LoadAll.FAILED] ({ commit, dispatch }, payload) {

  }
};

const mutations = {
  [Policies.Mutations.SET] (state, payload) {
    state.policies = payload;
  },

  [Policies.Mutations.CLEAR] (state) {
    state.policies = [];
  },

  [Policies.Mutations.IsLoading.SET] (state, payload) {
    state.isPoliciesLoading = payload;
  },

  [Policies.Mutations.IsLoading.CLEAR] (state) {
    state.isPoliciesLoading = false;
  },

  [Policies.Mutations.Errors.SET] (state, payload) {
    state.policiesErrors = payload;
  },

  [Policies.Mutations.Errors.CLEAR] (state) {
    state.policiesErrors = [];
  },

  [App.Mutations.CLEAR] (state) {
    state.policies = [];
    state.policiesErrors = [];
    state.isPoliciesLoading = false;
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
